var map = {
	"./about-us-header.jpg": 980,
	"./about-us-header@2x.jpg": 981,
	"./building.jpg": 982,
	"./building@2x.jpg": 983,
	"./contacts-header.jpg": 984,
	"./contacts-header@2x.jpg": 985,
	"./favicons/android-chrome-192x192.png": 986,
	"./favicons/android-chrome-256x256.png": 987,
	"./favicons/apple-touch-icon-114x114.png": 988,
	"./favicons/apple-touch-icon-120x120.png": 989,
	"./favicons/apple-touch-icon-144x144.png": 990,
	"./favicons/apple-touch-icon-152x152.png": 991,
	"./favicons/apple-touch-icon-180x180.png": 992,
	"./favicons/apple-touch-icon-57x57.png": 993,
	"./favicons/apple-touch-icon-60x60.png": 994,
	"./favicons/apple-touch-icon-72x72.png": 995,
	"./favicons/apple-touch-icon-76x76.png": 996,
	"./favicons/apple-touch-icon.png": 997,
	"./favicons/favicon-16x16.png": 998,
	"./favicons/favicon-32x32.png": 999,
	"./favicons/favicon.ico": 1000,
	"./favicons/mstile-144x144.png": 1001,
	"./flags/aoa.png": 443,
	"./flags/eur.png": 444,
	"./flags/usd.png": 445,
	"./flags/vef.png": 446,
	"./for-agents-header.jpg": 1002,
	"./for-agents-header@2x.jpg": 1003,
	"./hero-image.jpg": 1004,
	"./hero-image@2x.jpg": 1005,
	"./how-it-works-header.jpg": 1006,
	"./how-it-works-header@2x.jpg": 1007,
	"./lead-header.jpg": 1008,
	"./lead-header@2x.jpg": 1009,
	"./licensed-header.jpg": 1010,
	"./licensed-header@2x.jpg": 1011,
	"./logos/airtm.png": 1012,
	"./logos/airtm@2x.png": 1013,
	"./logos/babb.png": 1014,
	"./logos/babb@2x.png": 1015,
	"./logos/corillian.png": 1016,
	"./logos/corillian@2x.png": 1017,
	"./logos/m35ltd.png": 1018,
	"./logos/m35ltd@2x.png": 1019,
	"./logos/uphold.png": 1020,
	"./logos/uphold@2x.png": 1021,
	"./pattern-1.jpg": 1022,
	"./pattern-1@2x.jpg": 1023,
	"./pattern-2.jpg": 1024,
	"./pattern-2@2x.jpg": 1025,
	"./social-pic.jpg": 447,
	"./team/carlos-veiga.jpeg": 1026,
	"./team/carlos-veiga@2x.jpeg": 1027,
	"./team/jorge-pereira.jpeg": 1028,
	"./team/jorge-pereira@2x.jpeg": 1029,
	"./team/thomas-brooke.jpeg": 1030,
	"./team/thomas-brooke@2x.jpeg": 1031,
	"./team/timothy-parsa.jpeg": 1032,
	"./team/timothy-parsa@2x.jpeg": 1033,
	"./team/winston-ling.jpeg": 1034,
	"./team/winston-ling@2x.jpeg": 1035
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 244;



//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images ^\.\/.*$
// module id = 244
// module chunks = 0